export default "__VITE_ASSET__4c68a6f7__"